import React, { useState, useEffect, useCallback } from "react";
import "./Principal.scss";
import Slider from "../Slider/Slider";
import { SwiperSlide } from "swiper/react";
import Modal from "../Modal/Modal";
import { useTranslation } from "react-i18next";

const images = [
  { src: "./assets/Principal/1img.jpg", alt: "Velasur exterior 1" },
  { src: "./assets/Principal/2img.jpg", alt: "Velasur exterior 2" },
  { src: "./assets/Principal/3img.jpg", alt: "Velasur exterior 3" },
  { src: "./assets/Principal/4img.jpg", alt: "Velasur exterior 4" },
  { src: "./assets/Principal/5img.jpg", alt: "Velasur exterior 5" },
  { src: "./assets/Principal/6img.jpg", alt: "Velasur exterior 6" },
];

const Principal = (props) => {
  const { t } = useTranslation();
  const [y, setY] = useState(window.scrollY);
  const [showStiky, setShowStiky] = useState("ocultar");
  const [modalOpen, setModalOpen] = useState(false);

  const handleNavigation = useCallback(
    (e) => {
      const window = e.currentTarget;
      if (y > window.scrollY) {
        if (window.scrollY <= 100) {
          setShowStiky("ocultar");
        }
      } else if (y < window.scrollY) {
        if (window.scrollY >= 100) {
          setShowStiky("mostrar");
        }
      }
      setY(window.scrollY);
    },
    [y]
  );

  useEffect(() => {
    setY(window.scrollY);
    window.addEventListener("scroll", handleNavigation);
    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, [handleNavigation]);

  return (
    <div className={`contenedor__principal ${showStiky}`}>
      <div className="contenedor__principal_carousel">
        <Slider nav={true} pag={false}>
          {images.map((img) => (
            <SwiperSlide key={img.src}>
              <div className="contenedor__principal_carousel__slider">
                <img src={img.src} alt={img.alt} />

                {/* Si quieres usar el overlay, descomenta y adapta textos */}
                {/* 
                <div className="overlay">
                  <h2 className="overlay-text">{t('principal.casasTerrenos')}</h2>
                  <p className="overlay-text1">{t('principal.descripcion1')}</p>
                  <div className="overlay-buttons">
                    <a
                      className="whatsappoverlay"
                      href="https://api.whatsapp.com/send?phone=524428801675&text"
                    >
                      <button className="btn-primary">
                        {t('principal.respuestasWhatsapp')}
                      </button>
                    </a>
                    <button
                      className="btn-secondary"
                      onClick={() => setModalOpen(true)}
                    >
                      {t('principal.descripcion2')}
                    </button>
                  </div>
                </div>
                */}
              </div>
            </SwiperSlide>
          ))}
        </Slider>
      </div>

      <div className="bottom_info">
        <div className="icon-scroll"></div>
        <div className="whatsapp">
          <a
            id="ws_script"
            href="https://api.whatsapp.com/send?phone=524428801675&text"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://multipagos.velasresorts.com/images/WhatsApp_Logo_1.png"
              width="65"
              height="65"
              alt="WhatsApp"
            />
          </a>
        </div>
        <div className="texto">
          <p>{t("principal.lotesPremium")}</p>
        </div>
      </div>

      {modalOpen && <Modal setModal={setModalOpen} />}
    </div>
  );
};

export default Principal;
